import React from 'react';

import { LifeAreaSummaryHeader } from './components/life-area-summary-header/life-area-summary-header';
import { SummaryRoadmap } from './summary-roadmap';
import { Tasks } from './tasks';

export const Summary: React.FC = () => (
  <>
    <LifeAreaSummaryHeader />
    <SummaryRoadmap />
    <Tasks grow hasLink />
  </>
);
